import * as styled from '../styles/footer';

type Props = {
  onSelectPro: () => void;
  onSelectCreator: () => void;
};

export const Footer = ({ onSelectPro, onSelectCreator }: Props) => (
  <styled.Bar>
    <styled.LogoGroup>
      <styled.LogoMark>K</styled.LogoMark>
      <styled.Wordmark>kudable.com</styled.Wordmark>
    </styled.LogoGroup>
    <styled.LinkRow>
      <styled.FooterLink type="button" onClick={onSelectPro}>
        For pros
      </styled.FooterLink>
      <styled.FooterLink type="button" onClick={onSelectCreator}>
        For creators
      </styled.FooterLink>
      <styled.ContactLink href="mailto:hello@kudable.com">Contact</styled.ContactLink>
    </styled.LinkRow>
    <styled.Copyright>© {new Date().getFullYear()} Kudable</styled.Copyright>
  </styled.Bar>
);
